import App from "./App.svelte";

// @ts-ignore
new App({
  target: document.body,
});
